<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="consumable">Consumable</label>
                    <wj-auto-complete
                        id="consumable"
                        [(ngModel)]="target.material"
                        name="material"
                        [isEditable]="false"
                        [maxItems]="100"
                        [itemsSource]="materialOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-auto-complete>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="location">Location</label>
                    <wj-auto-complete
                        id="location"
                        [(ngModel)]="target.location"
                        name="location"
                        [isEditable]="false"
                        [maxItems]="100"
                        [itemsSource]="locationOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-auto-complete>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="quantity">Quantity</label>
                    <input id="quantity" type="number" class="form-control" [(ngModel)]="target.quantity" name="quantity" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
